import {
  Accordion,
  Card,
  Group,
  Text,
  useMantineColorScheme,
  useMantineTheme,
} from "@mantine/core";

export default function HelpComponent() {
  const { colorScheme } = useMantineColorScheme();
  const theme = useMantineTheme();
  return (
    <Card radius="md" p="md" withBorder>
      <Text fw={600} mb="md">
        Help
      </Text>

      {/* Application Walkthrough */}
      <Card withBorder>
        <Group justify="space-between">
          <Text>Application Walkthrough</Text>
          <Text c="blue" size="sm" style={{ cursor: "pointer" }}>
            Start
          </Text>
        </Group>
      </Card>

      {/* FAQs Accordion */}
      <Accordion
        mt="sm"
        variant="contained"
        radius={"xl"}
        
        styles={{
          item: {
            border: `1px solid ${colorScheme === "dark" ? theme.colors.gray[7] : theme.colors.gray[3]}`,
            borderRadius: "10px",
            marginBottom: "8px",
          },
          panel: {
            borderTop: "none",
            borderLeft: "none", 
            borderRight: "none",
            borderBottom: "none",
          },
          control: {
            borderTop: "none",
            borderLeft: "none", 
            borderRight: "none",
            borderBottom: `1px solid ${colorScheme === "dark" ? theme.colors.gray[7] : theme.colors.gray[3]}`,
          },
        }}
      >
        <Accordion.Item value="q1">
          <Accordion.Control>What is OneSelf Path® ?</Accordion.Control>
          <Accordion.Panel>
            OneSelf Path® turns the guidance your care team follows into short,
            plain-language steps that match your own health records. Each path
            covers one condition, and each waypoint on it is something you can
            read, rate and bookmark at your own pace.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item value="q2">
          <Accordion.Control>How can I reset my password?</Accordion.Control>
          <Accordion.Panel>
            To reset your password, go to settings, click change password, and
            follow the prompts.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item value="q3">
          <Accordion.Control>How can I update my email Id?</Accordion.Control>
          <Accordion.Panel>
            Navigate to Profile settings and edit your email field, then save
            changes.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item value="q4">
          <Accordion.Control>
            What information does OneSelf Path® collect about me?
          </Accordion.Control>
          <Accordion.Panel>
            We collect basic profile information to personalize your experience.
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Card>
  );
}
